import { mobile, tablet } from "components/templates/Breakpoints";
import styled from "styled-components";
import { color } from "@styles";

export const TrophyYugi = styled.div`
  width: 30rem;
  height: 28.9rem;
  margin-top: 3rem;
  position: static;
  overflow: hidden;

  @media only screen and (max-width: 70rem) {
    height: 32.5rem;
    width: 23.75rem;
    margin-top: 2rem;
  }

  ${tablet} {
    height: 28rem;
    width: 21rem;
    margin-top: 2rem;
  }

  @media only screen and (max-width: 55rem) {
    height: 22rem;
    width: 16.5rem;
    margin-top: 5rem;
  }

  @media only screen and (max-width: 50rem) {
    display: none;
  }
`;

export const Tooltip = styled.div`
  p {
    line-height: 1.5rem;
    letter-spacing: 0.075rem;
    text-align: center;
    font-weight: normal;
    color: ${color.B1100};
    font-size: 1rem;
  }

  a {
    color: ${color.yulifePink.P100};
  }
`;
export const CenteredButtonWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 7.5rem;

  ${mobile} {
    padding-bottom: 4rem;
  }
`;
